import React, { useEffect, useState } from 'react';
import { BlockPicker, ColorResult } from 'react-color';

import { AvatarIcon } from './assets/svg/AvatarIcon';
import { RoutalDefaultColors } from './Colors';
import { ColorSample } from './RoutalColorPicker';
import { RoutalText } from './RoutalText';

type RoutalAvatarColorPickerProps = {
  color?: string;
  label?: string | React.ReactElement;
  sizeInPx?: number;
  presetColors?: string[];
  onUpdate: (...args: any[]) => any;
  colorSampleContent?: React.ReactElement;
  colorSampleStyles?: React.CSSProperties;
  containerStyles?: React.CSSProperties;
  avatar?: string | null;
};

export const RoutalAvatarColorPicker = ({
  color = RoutalDefaultColors[0],
  label,
  sizeInPx = 38,
  presetColors = RoutalDefaultColors,
  onUpdate,
  colorSampleContent,
  colorSampleStyles = {},
  containerStyles = {},
  avatar,
}: RoutalAvatarColorPickerProps) => {
  const [currentColor, setCurrentColor] = useState<string | undefined>();
  const [showColorPicker, setShowColorPicker] = useState<boolean>(false);

  useEffect(() => {
    if (color) {
      setCurrentColor(color);
    }
  }, [color]);

  const handleColorChange = ({ hex }: ColorResult) => {
    onUpdate(hex);
    setShowColorPicker(false);
  };

  const borderSize = Math.round((2 * sizeInPx) / 38);

  return (
    <>
      {label && <RoutalText variant="label">{label}</RoutalText>}

      <div
        style={{
          position: `relative`,
          ...containerStyles,
          width: `${sizeInPx}px`,
          height: `${sizeInPx}px`,
        }}
      >
        <ColorSample
          style={{
            ...colorSampleStyles,
            width: `${sizeInPx}px`,
            height: `${sizeInPx}px`,
          }}
          onClick={(e: any) => {
            setShowColorPicker(!showColorPicker);
          }}
          color={currentColor}
        >
          {colorSampleContent}
          {avatar ? (
            <div
              style={{
                borderRadius: `50%`,
                overflow: `hidden`,
                position: `absolute`,
                width: `calc(${sizeInPx}px - ${borderSize * 2}px)`,
                height: `calc(${sizeInPx}px - ${borderSize * 2}px)`,
                left: `${borderSize}px`,
                top: `${borderSize}px`,
              }}
            >
              {avatar ? (
                <img
                  draggable="false"
                  src={avatar}
                  alt="vehicle_avatar"
                  style={{
                    width: `100%`,
                    height: `auto`,
                  }}
                />
              ) : null}
            </div>
          ) : (
            <AvatarIcon
              color={currentColor}
              style={{
                width: `${sizeInPx}px`,
                height: `${sizeInPx}px`,
              }}
            />
          )}
        </ColorSample>

        {showColorPicker ? (
          <div
            style={{
              position: `absolute`,
              top: `100%`,
              left: `50%`,
              transform: `translateX(-50%)`,
              marginTop: 15,
              zIndex: 2,
              boxShadow: `rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px`,
              borderRadius: `6px`,
            }}
          >
            <BlockPicker color={currentColor} colors={presetColors || []} onChangeComplete={handleColorChange} />
          </div>
        ) : null}
      </div>
    </>
  );
};
